import { render, staticRenderFns } from "./VenueTrainingDangerZone.vue?vue&type=template&id=519688b1"
import script from "./VenueTrainingDangerZone.vue?vue&type=script&lang=js"
export * from "./VenueTrainingDangerZone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports